var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',[_c('SiteMasthead',{attrs:{"mini":true,"title":"“Working closely with the best and the brightest”","image":{ source: '/assets/images/photos/giving-back', formats: ['avif', 'webp', 'jpg'], fallback: 'jpg' }}}),_c('ContentRow',{attrs:{"noPadding":true}},[_c('Blogs',{attrs:{"filter":_vm.filter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }